export function segmentMatcherContext(segmentName, storage) {
    return function segmentMatcher(key) {
        var isInSegment = storage.segments.isInSegment(segmentName, key);
        return isInSegment;
    };
}
